import router from './index'
import store from '@/store/index'

router.beforeEach((to, from, next) => {    
    if (store.state.user === null && to.path !== '/login') {   
      next('/login');  
    } else {  
      next();  
    }  
  });